module.exports = __webpack_public_path__ + "static/media/boy.dae5784b.svg";